import { render, staticRenderFns } from "./PersistentVolumeClaims.vue?vue&type=template&id=3b0b58ce&"
import script from "./PersistentVolumeClaims.vue?vue&type=script&lang=js&"
export * from "./PersistentVolumeClaims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports